import { supabase } from "./supabase";

async function authorizedFetch(accountId: string, method: "GET" | "PATCH" | "POST", body?: Record<string, unknown>) {
  const { data } = await supabase.auth.getSession().catch(() => ({ data: { session: null } }));
  if (!data.session?.access_token) throw new Error("Sign in with platform-operator access to manage CAI discovery.");
  const response = await fetch(`/api/admin/cai-discovery${method === "GET" ? `?accountId=${encodeURIComponent(accountId)}` : ""}`, {
    method,
    headers: { Authorization: `Bearer ${data.session.access_token}`, "Content-Type": "application/json" },
    ...(body ? { body: JSON.stringify(body) } : {}),
  }).catch(() => { throw new Error("CAI discovery is temporarily unavailable."); });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const messages: Record<string, string> = {
      cai_preview_mutation_not_allowed: "CAI discovery changes are disabled in this Preview.",
      cai_sitemap_url_limit_exceeded: "Enter no more than eight sitemap URLs.",
      cai_target_url_limit_exceeded: "Enter no more than 20 target page URLs.",
      cai_discovery_url_invalid: "Each URL must be a safe page on the selected account's website.",
      cai_discovery_run_not_current: "Refresh is available only for the current completed run.",
      cai_discovery_run_not_completed: "Refresh is available only after the selected run completes.",
    };
    if (response.status === 401 || response.status === 403) throw new Error(messages[result.code] || "Platform-operator access to this account is required.");
    throw new Error(messages[result.code] || "CAI discovery is temporarily unavailable.");
  }
  return result;
}

export function loadCaiDiscoverySettings(accountId: string) {
  return authorizedFetch(accountId, "GET");
}

export function saveCaiDiscoverySettings(accountId: string, sitemapUrls: string[], targetAssetUrls: string[]) {
  return authorizedFetch(accountId, "PATCH", { accountId, sitemapUrls, targetAssetUrls });
}

export function refreshCaiDiscovery(accountId: string, runId: string) {
  return authorizedFetch(accountId, "POST", { accountId, runId });
}
